export default "__VITE_ASSET__Bp4umq3f__"